import { SVGProps } from 'react';

export const BookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M6 3.52084C5.20387 2.80828 4.15253 2.375 3 2.375C2.47405 2.375 1.96917 2.46523 1.5 2.63106V9.75606C1.96917 9.59023 2.47405 9.5 3 9.5C4.15253 9.5 5.20387 9.93328 6 10.6458M6 3.52084C6.79613 2.80828 7.84747 2.375 9 2.375C9.52595 2.375 10.0308 2.46523 10.5 2.63106V9.75606C10.0308 9.59023 9.52595 9.5 9 9.5C7.84747 9.5 6.79613 9.93328 6 10.6458M6 3.52084V10.6458'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
